import {
    AlertTriangle,
    BookOpen,
    CalendarClock,
    Stethoscope,
    UserRound,
} from 'lucide-react';

// How chat entities look: icons, colors, pill classes, and the user bubble.
//
// A leaf on purpose. The real chat and mockups of it (the Learn Phoebe fake
// chat) both style from here so the two cannot drift — but a mockup must not
// have to import chat_view.tsx to learn what a caregiver pill looks like, or
// its tests inherit that module's entire graph.

export type EntityType =
    | 'caregiver'
    | 'client'
    | 'shift'
    | 'callout'
    | 'playbook';

export const ENTITY_CONFIG = {
    shift: { icon: CalendarClock, label: 'Shift', color: 'text-blue-600' },
    caregiver: {
        icon: Stethoscope,
        label: 'Caregiver',
        color: 'text-green-600',
    },
    client: { icon: UserRound, label: 'Client', color: 'text-purple-600' },
    callout: {
        icon: AlertTriangle,
        label: 'Open Shift',
        color: 'text-amber-600',
    },
    playbook: { icon: BookOpen, label: 'Playbook', color: 'text-teal-600' },
} as const;

export const ENTITY_PILL_CLASSES: Record<EntityType, string> = {
    caregiver: 'bg-green-50 text-green-700',
    client: 'bg-purple-50 text-purple-700',
    shift: 'bg-blue-50 text-blue-700',
    callout: 'bg-amber-50 text-amber-700',
    playbook: 'bg-teal-50 text-teal-700',
};

export const USER_MESSAGE_BUBBLE_CLASSES =
    'w-fit max-w-[min(100%,42rem)] min-w-0 [overflow-wrap:anywhere] break-words rounded-xl bg-[#ECECEC] px-3.5 py-2 text-sm text-[#2E2E2E]';

// Workbench / training-mode user bubble. Cap width with min() so narrow
// docked chat and the full-page chat share one responsive rule.
export const WORKBENCH_USER_MESSAGE_BUBBLE_CLASSES =
    'w-fit max-w-[min(100%,40rem)] min-w-0 [overflow-wrap:anywhere] break-words rounded-xl border border-[#DBE3E3] bg-[#F0F5F5] px-3 py-2 text-left text-[13px] leading-5 text-[#002429] shadow-[0_1px_0_rgba(0,36,41,0.04)]';

// Next-action choices reuse the workbench bubble and add tap affordances.
export const NEXT_ACTION_CHOICE_BUBBLE_CLASSES = `${WORKBENCH_USER_MESSAGE_BUBBLE_CLASSES} cursor-pointer transition-colors hover:border-[#C5D0D0] hover:bg-[#E7EEEE] disabled:cursor-not-allowed disabled:opacity-50`;
